(function () {
  'use strict';

  /* ── Guard: skip non-restoration pages and product pages we don't want ── */
  var PAGE_URL   = (window.location.pathname || '').toLowerCase();
  var PAGE_TITLE = (document.title || '').toUpperCase();
  var BLOCKED = ['replacement-laces','cushioned-insoles','crease-protectors','shoe-trees','spare-laces'];
  for (var b = 0; b < BLOCKED.length; b++) { if (PAGE_URL.indexOf(BLOCKED[b]) !== -1) { return; } }
  var IS_RESTORATION = /refresh|revive|reborn/i.test(PAGE_TITLE) || /refresh|revive|reborn/i.test(PAGE_URL);
  if (!IS_RESTORATION) { return; }

  var IS_REVIVE  = /revive/i.test(PAGE_TITLE)  || /revive/i.test(PAGE_URL);
  var IS_REBORN  = /reborn/i.test(PAGE_TITLE)  || /reborn/i.test(PAGE_URL);
  var IS_REFRESH = !IS_REVIVE && !IS_REBORN;

  /* ── Constants ── */
  var P_STD = 3.99, P_HD = 6.99, P_INSOLE = 6.99;
  function laceStdPrice(n) { return P_STD; }
  function laceHdPrice(n) { return P_HD; }

  /* ── State ── */
  var deliveryExtra = 0;
  var slotCount = 0;
  var pairCount = 1;
  var COLOURS_STD  = ['White/White','White/Black','Black/White','Black/Black'];
  var COLOURS_HD   = ['Black/Grey','Black/White','Beige/Brown','Brown/Beige'];
  var SIZES_INSOLES = [], SIZES_CP = [], SIZES_ST = [];

  /* ── Helpers ── */
  function ge(id)  { return document.getElementById(id); }
  function ce(tag) { return document.createElement(tag); }
  function fmt(n)  { return '\u00A3' + n.toFixed(2); }

  /* ════════════════════════════════════════════════════════
     FETCH HELPERS
  ════════════════════════════════════════════════════════ */
  function fetchSizes(handle, cb) {
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(d) {
        var out = [], seen = {};
        (d.variants || []).forEach(function(v) {
          var s = (v.option1 || '').trim();
          if (!s || /standard|heavy|colour|type/i.test(s)) { s = (v.option2 || '').trim(); }
          if (s && !seen[s]) { seen[s] = true; out.push(s); }
        });
        cb(out);
      }).catch(function() { cb([]); });
  }

  function fetchLaceColours() {
    return fetch('/products/replacement-laces.js')
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(d) {
        var tS = [], tH = [], sS = {}, sH = {};
        (d.variants || []).forEach(function(v) {
          var tp  = (v.option1 || '').trim();
          var raw = (v.option2 || '').trim();
          if (!raw) { return; }
          var clean = raw.replace(/chunky/gi, '').replace(/\s{2,}/g, ' ').replace(/^[\s\/]+|[\s\/]+$/g, '').trim();
          if (!clean) { return; }
          if (/heavy/i.test(tp)) { if (!sH[clean]) { sH[clean] = true; tH.push(clean); } }
          else                   { if (!sS[clean]) { sS[clean] = true; tS.push(clean); } }
        });
        console.log('[RF] Colours — Std:', tS, 'HD:', tH);
        if (tS.length) { COLOURS_STD = tS; }
        if (tH.length) { COLOURS_HD  = tH; }
      }).catch(function() {});
  }

  /* ════════════════════════════════════════════════════════
     DOM BUILDERS
  ════════════════════════════════════════════════════════ */
  function buildColourSel(type) {
    var list = /heavy/i.test(type) ? COLOURS_HD : COLOURS_STD;
    var sel = ce('select'); sel.className = 'rf-select rf-lace-colour-select'; sel.style.fontFamily = '"Space Grotesk",sans-serif'; sel.style.fontSize = '1rem';
    var blank = ce('option'); blank.value = ''; blank.textContent = 'Select colour\u2026'; sel.appendChild(blank);
    list.forEach(function(c) { var o = ce('option'); o.value = c; o.textContent = c; sel.appendChild(o); });
    sel.addEventListener('change', recalc);
    return sel;
  }

  function buildSizeSelect(sizes, id, ph) {
    var sel = ce('select'); sel.className = 'rf-select rf-size-select'; sel.id = id; sel.style.fontFamily = '"Space Grotesk",sans-serif'; sel.style.fontSize = '1rem';
    var blank = ce('option'); blank.value = ''; blank.textContent = ph || 'Select size\u2026'; sel.appendChild(blank);
    var list = sizes && sizes.length ? sizes : [];
    if (!list.length && id.indexOf('-in-') !== -1) {
      for (var i = 3; i <= 12; i++) { list.push('UK ' + i); }
    }
    list.forEach(function(s) { var o = ce('option'); o.value = s; o.textContent = s; sel.appendChild(o); });
    sel.addEventListener('change', recalc);
    return sel;
  }

  function buildSlot(slotN) {
    var stdP = laceStdPrice(slotN), hdP = laceHdPrice(slotN);
    var stdTxt = 'Standard (' + fmt(P_STD) + ')';
    var hdTxt  = 'Heavy-Duty (' + fmt(P_HD) + ')';

    var div = ce('div'); div.className = 'rf-lace-slot'; div.setAttribute('data-slot', slotN);

    var lbl = ce('p'); lbl.className = 'rf-lace-slot-label'; lbl.textContent = 'Pair ' + slotN;
    div.appendChild(lbl);

    var opts = ce('div'); opts.className = 'rf-lace-options';
    [{v:'none',p:0,t:'No thanks'},{v:'Standard',p:stdP,t:stdTxt},{v:'Heavy-Duty Trail',p:hdP,t:hdTxt}]
      .forEach(function(o, i) {
        var btn = ce('button'); btn.type = 'button';
        btn.className = 'rf-lace-btn' + (i === 0 ? ' rf-lace-btn--active' : '');
        btn.setAttribute('data-value', o.v); btn.setAttribute('data-price', String(o.p));
        btn.textContent = o.t;
        /* Direct listener — no delegation, no closest(), works everywhere */
        btn.addEventListener('click', function(e) {
          e.preventDefault(); e.stopPropagation();
          slot_click(btn, div);
        });
        opts.appendChild(btn);
      });
    div.appendChild(opts);

    var cw = ce('div'); cw.className = 'rf-lace-colour-wrap'; cw.style.display = 'none';
    var cl = ce('label'); cl.className = 'rf-label'; cl.innerHTML = 'LACE COLOUR <span class="rf-required">*</span>';
    cw.appendChild(cl);
    var csw = ce('div'); csw.className = 'rf-select-wrap'; csw.appendChild(buildColourSel('Standard')); cw.appendChild(csw);
    var cerr = ce('p'); cerr.className = 'rf-colour-error'; cerr.textContent = 'Please choose a lace colour.';
    cerr.style.display = 'none'; cw.appendChild(cerr);
    div.appendChild(cw);

    /* No per-slot named properties — summary written to rf-prop-laces by recalc() */
    var ht = ce('input'); ht.type = 'hidden'; ht.className = 'rf-lace-type-hid'; ht.value = ''; div.appendChild(ht);
    var hc = ce('input'); hc.type = 'hidden'; hc.className = 'rf-lace-colour-hid'; hc.value = ''; div.appendChild(hc);
    var hp = ce('input'); hp.type = 'hidden'; hp.className = 'rf-lace-price-hid'; hp.value = '0'; div.appendChild(hp);

    return div;
  }

  function slot_click(btn, slot) {
    slot.querySelectorAll('.rf-lace-btn').forEach(function(b) { b.classList.remove('rf-lace-btn--active'); });
    btn.classList.add('rf-lace-btn--active');
    var cw  = slot.querySelector('.rf-lace-colour-wrap');
    var csw = cw ? cw.querySelector('.rf-select-wrap') : null;
    var tv  = btn.getAttribute('data-value');
    if (tv === 'none') {
      if (cw) { cw.style.display = 'none'; }
      if (parseInt(slot.getAttribute('data-slot')) > 1 && slot.parentNode) {
        slot.parentNode.removeChild(slot);
        refreshSlotLabels();
      }
    } else {
      if (csw) { csw.innerHTML = ''; csw.appendChild(buildColourSel(tv)); }
      if (cw)  { cw.style.display = 'block'; }
    }
    recalc();
  }

  function refreshSlotLabels() {
    if (!wrap) { return; }
    var all = wrap.querySelectorAll('.rf-lace-slot');
    all.forEach(function(s) {
      var l = s.querySelector('.rf-lace-slot-label');
      if (l) { l.style.display = all.length > 1 ? 'block' : 'none'; }
    });
  }

  /* ════════════════════════════════════════════════════════
     MULTI-PAIR: extra trainer detail blocks
  ════════════════════════════════════════════════════════ */
  function buildExtraPairBlock(pn) {
    var UK_SIZES_MP = [];
    for (var i = 3; i <= 15; i++) {
      UK_SIZES_MP.push('UK ' + i);
      if (i < 15) UK_SIZES_MP.push('UK ' + i + '.5');
    }

    var block = ce('div');
    block.className = 'rf-extra-pair';
    block.id = 'rf-extra-pair-' + pn + '-' + SID;

    var header = ce('div');
    header.className = 'rf-extra-pair-header';
    var lbl = ce('span');
    lbl.className = 'rf-extra-pair-lbl';
    lbl.textContent = 'Pair ' + pn + ' details';
    var removeBtn = ce('button');
    removeBtn.type = 'button';
    removeBtn.className = 'rf-extra-pair-remove';
    removeBtn.textContent = '✕ Remove';
    removeBtn.addEventListener('click', function() {
      block.parentNode.removeChild(block);
      pairCount--;
      /* Renumber remaining extra pairs */
      var extras = document.querySelectorAll('.rf-extra-pair');
      extras.forEach(function(ep, idx) {
        var newN = idx + 2;
        var lbl2 = ep.querySelector('.rf-extra-pair-lbl');
        if (lbl2) { lbl2.textContent = 'Pair ' + newN + ' details'; }
      });
      recalc();
      updatePairDiscount();
    });
    header.appendChild(lbl);
    header.appendChild(removeBtn);
    block.appendChild(header);

    var fields = ce('div');
    fields.className = 'rf-extra-pair-fields';

    /* Service Tier */
    if (!document.getElementById('rf-tier-picker-styles')) {
      var st2 = ce('style'); st2.id = 'rf-tier-picker-styles';
      st2.textContent = '.rf-tier-picker{display:flex;gap:6px;margin-bottom:2px;}.rf-tier-opt{flex:1;border:2px solid #ddd;border-radius:10px;padding:10px 6px;cursor:pointer;text-align:center;transition:border-color 0.15s,background 0.15s;background:#fff;user-select:none;}.rf-tier-opt:hover{border-color:#aaa;}.rf-tier-opt--active{border-color:#264C21!important;background:#eef6ec;}.rf-tier-opt-name{font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:#1A1A1A;display:block;margin-bottom:3px;}.rf-tier-opt-orig{font-size:11px;color:#999;text-decoration:line-through;display:none;line-height:1.3;}.rf-tier-opt-price{font-size:14px;font-weight:700;color:#264C21;display:block;}';
      document.head.appendChild(st2);
    }
    var tl = ce('label'); tl.className = 'rf-label'; tl.innerHTML = 'SERVICE TIER <span class="rf-required">*</span>';
    var tw = ce('div'); tw.className = 'rf-tier-picker'; tw.setAttribute('data-tier-picker', '');
    var ts = ce('input'); ts.type = 'hidden'; ts.id = 'rf-tier-p' + pn + '-' + SID; ts.value = 'revive';
    tw.appendChild(ts);
    var TIER_DEFS = [
      { value: 'refresh', name: 'REFRESH', price: 33 },
      { value: 'revive',  name: 'REVIVE',  price: 48 },
      { value: 'reborn',  name: 'REBORN',  price: 75 }
    ];
    TIER_DEFS.forEach(function(def) {
      var opt2 = ce('div');
      opt2.className = 'rf-tier-opt' + (def.value === 'revive' ? ' rf-tier-opt--active' : '');
      opt2.setAttribute('data-tier-value', def.value);
      opt2.setAttribute('data-tier-price', String(def.price));
      opt2.innerHTML = '<span class="rf-tier-opt-name">' + def.name + '</span><span class="rf-tier-opt-orig">\u00A3' + def.price + '</span><span class="rf-tier-opt-price">\u00A3' + def.price + '</span>';
      opt2.addEventListener('click', function() {
        tw.querySelectorAll('.rf-tier-opt').forEach(function(o2) { o2.classList.remove('rf-tier-opt--active'); });
        opt2.classList.add('rf-tier-opt--active');
        ts.value = def.value;
        recalc();
      });
      tw.appendChild(opt2);
    });

    /* Model */
    var ml = ce('label'); ml.className = 'rf-label'; ml.innerHTML = 'TRAINER MODEL <span class="rf-required">*</span>';
    var mi = ce('input'); mi.type = 'text'; mi.className = 'rf-input';
    mi.id = 'rf-model-p' + pn + '-' + SID;
    mi.placeholder = 'e.g. Nike Air Force 1, Adidas Samba';
    mi.addEventListener('input', recalc);

    /* Size */
    var sl = ce('label'); sl.className = 'rf-label'; sl.innerHTML = 'UK SIZE <span class="rf-required">*</span>';
    var sw = ce('div'); sw.className = 'rf-select-wrap';
    var ss = ce('select'); ss.className = 'rf-select';
    ss.id = 'rf-size-p' + pn + '-' + SID;
    var blank = ce('option'); blank.value = ''; blank.textContent = 'Select your size...';
    ss.appendChild(blank);
    UK_SIZES_MP.forEach(function(sz) { var o = ce('option'); o.value = sz; o.textContent = sz; ss.appendChild(o); });
    ss.addEventListener('change', recalc);
    sw.appendChild(ss);

    /* Notes */
    var nl = ce('label'); nl.className = 'rf-label';
    nl.innerHTML = 'EXTRA NOTES <span class="rf-label-opt">(optional)</span>';
    var ni = ce('input'); ni.type = 'text'; ni.className = 'rf-input';
    ni.id = 'rf-notes-p' + pn + '-' + SID;
    ni.placeholder = 'e.g. heavy creasing, yellowed sole...';
    ni.addEventListener('input', recalc);

    fields.appendChild(tl); fields.appendChild(tw);
    fields.appendChild(ml); fields.appendChild(mi);
    fields.appendChild(sl); fields.appendChild(sw);
    fields.appendChild(nl); fields.appendChild(ni);
    block.appendChild(fields);

    return block;
  }

  function refreshExtraPairDiscounts() {
    var discountPct = pairCount >= 3 ? 20 : (pairCount >= 2 ? 10 : 0);
    var factor = 1 - discountPct / 100;
    document.querySelectorAll('[data-tier-picker]').forEach(function(picker) {
      picker.querySelectorAll('.rf-tier-opt').forEach(function(opt2) {
        var baseP = parseFloat(opt2.getAttribute('data-tier-price')) || 0;
        var discP = Math.round(baseP * factor * 100) / 100;
        var origEl = opt2.querySelector('.rf-tier-opt-orig');
        var priceEl = opt2.querySelector('.rf-tier-opt-price');
        if (origEl && priceEl) {
          if (discountPct > 0) {
            origEl.style.display = 'block';
            priceEl.textContent = '\u00A3' + discP.toFixed(2);
          } else {
            origEl.style.display = 'none';
            priceEl.textContent = '\u00A3' + baseP.toFixed(2);
          }
        }
      });
    });
  }

  function updatePairDiscount() {
    var discBanner = document.querySelector('.rf-multi-discount-banner');
    if (!discBanner) { return; }
    if (pairCount >= 3) {
      discBanner.style.background = '#2d5a27';
      discBanner.style.color = '#fff';
      discBanner.style.borderColor = '#2d5a27';
      discBanner.innerHTML = '🏷️ <strong>20% multi-pair discount active!</strong> &nbsp;|&nbsp; ' + pairCount + ' pairs in this order';
    } else if (pairCount === 2) {
      discBanner.style.background = '#eef6ec';
      discBanner.style.color = '#2d5a27';
      discBanner.style.borderColor = '#c8d8c8';
      discBanner.innerHTML = '🏷️ <strong>10% multi-pair discount active!</strong> &nbsp;|&nbsp; Add 1 more pair for 20% off';
    } else {
      discBanner.style.background = '';
      discBanner.style.color = '';
      discBanner.style.borderColor = '';
      discBanner.innerHTML = '🏷️ <strong>Multi-pair discount:</strong> 10% off 2 pairs &nbsp;|&nbsp; 20% off 3+ pairs';
    }
    refreshExtraPairDiscounts();
  }

  /* ════════════════════════════════════════════════════════
     POPUP / VALIDATION
  ════════════════════════════════════════════════════════ */
  function showPopup(msg) {
    var ex = ge('rf-popup'); if (ex) { ex.parentNode.removeChild(ex); }
    if (!ge('rf-popup-anim')) {
      var st = ce('style'); st.id = 'rf-popup-anim';
      st.textContent = '@keyframes rfIn{from{opacity:0;transform:translateX(-50%) translateY(-10px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}';
      document.head.appendChild(st);
    }
    var p = ce('div'); p.id = 'rf-popup';
    p.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);background:#c0392b;color:#fff;padding:14px 28px;border-radius:8px;font-size:0.92rem;font-weight:600;font-family:inherit;z-index:99999;box-shadow:0 4px 24px rgba(0,0,0,0.3);display:flex;align-items:center;gap:10px;animation:rfIn 0.2s ease;';
    p.innerHTML = '<span style="font-size:1.2rem">&#9888;</span> ' + msg;
    document.body.appendChild(p);
    setTimeout(function() {
      p.style.transition = 'opacity 0.4s';
      p.style.opacity = '0';
      setTimeout(function() { p.parentNode && p.parentNode.removeChild(p); }, 400);
    }, 3500);
  }

  function highlightField(el, on) {
    if (!el) { return; }
    el.style.borderColor = on ? '#c0392b' : '';
    el.style.boxShadow   = on ? '0 0 0 3px rgba(192,57,43,0.18)' : '';
  }

  /* ════════════════════════════════════════════════════════
     RECALC
  ════════════════════════════════════════════════════════ */
  var wrap, SID, basePrice;

  function syncText() {
    /* Pair 1 — main fields */
    [['rf-model-'+SID,'rf-prop-model-'+SID],
     ['rf-size-'+SID, 'rf-prop-size-'+SID],
     ['rf-notes-'+SID,'rf-prop-notes-'+SID]].forEach(function(p) {
      var a = ge(p[0]), b = ge(p[1]); if (a && b) { b.value = a.value; }
    });
    /* Extra pairs */
    var allPairData = [];
    for (var pn = 1; pn <= pairCount; pn++) {
      var m = ge('rf-model-p'+pn+'-'+SID) || (pn===1 ? ge('rf-model-'+SID) : null);
      var s = ge('rf-size-p'+pn+'-'+SID)  || (pn===1 ? ge('rf-size-'+SID)  : null);
      var n = ge('rf-notes-p'+pn+'-'+SID) || (pn===1 ? ge('rf-notes-'+SID) : null);
      if (m && s) {
        var tierEl = ge('rf-tier-p'+pn+'-'+SID);
        var tierStr = tierEl ? tierEl.value.toUpperCase() : (pn===1 ? (IS_REBORN?'REBORN':(IS_REVIVE?'REVIVE':'REFRESH')) : '');
        allPairData.push('Pair '+pn+(tierStr?' ('+tierStr+')':'')+': '+(m.value.trim()||'?')+' / '+(s.value||'?')+(n&&n.value.trim()?' ('+n.value.trim()+')':''));
      }
    }
    var phid = ge('rf-prop-allpairs-'+SID);
    if (phid) { phid.value = allPairData.join(' | '); }
  }

  function recalc() {
    if (!wrap || !SID) { return; }
    syncText();
    var lacesTotal = 0, addonsTotal = 0, laceLines = [], addonLines = [];
    var colourErr = false, sizeErr = false;

    /* Laces */
    wrap.querySelectorAll('.rf-lace-slot').forEach(function(slot, i) {
      var sN  = parseInt(slot.getAttribute('data-slot')) || (i + 1);
      var ab  = slot.querySelector('.rf-lace-btn--active');
      var tv  = ab ? ab.getAttribute('data-value') : 'none';
      var pr  = parseFloat(ab ? ab.getAttribute('data-price') : 0) || 0;
      var cs  = slot.querySelector('.rf-lace-colour-select');
      var ch  = slot.querySelector('.rf-lace-colour-hid');
      var th  = slot.querySelector('.rf-lace-type-hid');
      var ph  = slot.querySelector('.rf-lace-price-hid');
      var er  = slot.querySelector('.rf-colour-error');
      if (th) { th.value = tv === 'none' ? '' : tv; }
      if (ph) { ph.value = pr; }
      if (tv !== 'none') {
        lacesTotal += pr;
        var col = cs ? cs.value : '';
        if (ch) { ch.value = col; }
        if (!col) { colourErr = true; if (er) { er.style.display = 'block'; } }
        else { if (er) { er.style.display = 'none'; } laceLines.push('Pair '+sN+': '+tv+' \u2013 '+col+(pr===0?' (FREE)':'')); }
      } else { if (ch) { ch.value = ''; } if (er) { er.style.display = 'none'; } }
    });

    /* Add-ons */
    var ac = ge('rf-addon-inputs-' + SID);
    if (ac) { ac.innerHTML = ''; }
    var mount = ge('rf-ao-mount-' + SID);
    if (mount) {
      mount.querySelectorAll('input[type="checkbox"][data-label]').forEach(function(cb) {
        var isInsole = cb.getAttribute('data-label') === 'Insoles';
        var aoId = cb.id.replace('ao-','').replace('-'+SID,'');
        var qEl  = ge('ao-'+aoId+'-qty-'+SID);
        var qty  = qEl ? (parseInt(qEl.textContent) || 1) : 1;
        var szEl = ge('ao-'+aoId+'-size-'+SID);
        var szEr = szEl ? szEl.closest('.rf-ao-size-wrap') : null;
        var szErrP = szEr ? szEr.querySelector('.rf-size-error') : null;
        if (!cb.checked) { if (szErrP) { szErrP.style.display = 'none'; } return; }
        if (szEl && !szEl.value) { sizeErr = true; if (szErrP) { szErrP.style.display = 'block'; } }
        else { if (szErrP) { szErrP.style.display = 'none'; } }
        var szStr = (szEl && szEl.value) ? ' (Size: ' + szEl.value + ')' : '';
        if (isInsole) {
          var lt = P_INSOLE * qty;
          addonsTotal += lt;
          addonLines.push('Insoles x'+qty+szStr+' '+fmt(lt));
          /* summary handled by rf-prop-addons — no per-item property needed */
        } else {
          var up = parseFloat(cb.getAttribute('data-price') || 0);
          var tot = up * qty;
          addonsTotal += tot;
          addonLines.push(cb.getAttribute('data-label')+(qty>1?' x'+qty:'')+szStr+' '+fmt(tot));
          /* summary handled by rf-prop-addons — no per-item property needed */
        }
      });
    }

    var combined = lacesTotal + addonsTotal;
    var tAdd = ge('rf-addons-total-'+SID);
    var tOrd = ge('rf-order-total-'+SID);
    var tBd  = ge('rf-order-breakdown-'+SID);
    if (tAdd) { tAdd.textContent = fmt(combined); }
    var discountFactor = pairCount >= 3 ? 0.8 : (pairCount >= 2 ? 0.9 : 1);
    refreshExtraPairDiscounts();
    var extraPairsTierTotal = 0;
    for (var epn = 2; epn <= pairCount; epn++) {
      var eptSel = ge('rf-tier-p' + epn + '-' + SID);
      if (eptSel) {
        var eptV = eptSel.value;
        var rawP = eptV === 'refresh' ? 33 : (eptV === 'reborn' ? 75 : 48);
        extraPairsTierTotal += Math.round(rawP * discountFactor * 100) / 100;
      }
    }
    var bd = 'Pair 1 ' + fmt(basePrice);
    if (extraPairsTierTotal > 0) { bd += ' \u2022 Extra pairs ' + fmt(extraPairsTierTotal); }
    if (deliveryExtra > 0) { bd += ' \u2022 Express Delivery (+' + fmt(deliveryExtra) + ')'; }
    else { bd += ' \u2022 Standard Delivery (FREE)'; }
    if (lacesTotal  > 0) { bd += ' \u2022 Laces '   + fmt(lacesTotal); }
    if (addonsTotal > 0) { bd += ' \u2022 Add-ons ' + fmt(addonsTotal); }
    if (tBd)  { tBd.textContent  = bd; }
    if (tOrd) { tOrd.textContent = fmt(basePrice + deliveryExtra + combined + extraPairsTierTotal); }

    var lHid = ge('rf-prop-laces-'+SID);
    var aHid = ge('rf-prop-addons-'+SID);
    var atHid= ge('rf-prop-atotal-'+SID);
    if (lHid)  { lHid.value  = laceLines.join(' | ') || 'No thanks'; }
    if (aHid)  { aHid.value  = addonLines.join(', ') || 'None'; }
    if (atHid) { atHid.value = fmt(addonsTotal); }

    var anyPaid = !!wrap.querySelector('.rf-lace-btn--active[data-value]:not([data-value="none"])');
    var addBtn = ge('rf-add-lace-pair-' + SID);
    if (addBtn) { addBtn.classList.toggle('rf-hidden', !anyPaid); }

    return !colourErr && !sizeErr;
  }

  /* ════════════════════════════════════════════════════════
     ADD-ONS
  ════════════════════════════════════════════════════════ */
  function buildAddons() {
    var mount = ge('rf-ao-mount-' + SID);
    if (!mount) { return; }
    mount.innerHTML = '';

    var ADDONS = [
      { id:'mc', label:'Microfibre Cloth',              price:3.99,  qty:false, sizes:null, handle:'microfibre-cloth' },
      { id:'sb', label:'Suede Brush',                   price:4.99,  qty:false, sizes:null, handle:'suede-brush' },
      { id:'bb', label:'Hard & Soft Bristle Brush Set', price:6.99,  qty:false, sizes:null, handle:'hard-and-soft-bristle-brush-set' },
      { id:'fc', label:'Foam Cleaner',                  price:12.99, qty:false, sizes:null, handle:'stain-wizard-sneaker-foam-cleaner-150ml' },
      { id:'sw', label:'Stain Wizard Set',              price:23.99, qty:false, sizes:null, handle:'complete-stain-wizard-set' }
    ];

    var list = ce('div'); list.style.cssText = 'display:flex;flex-direction:column;gap:9px;';

    ADDONS.forEach(function(ao) {
      var cbId   = 'ao-' + ao.id + '-' + SID;
      var qId    = 'ao-' + ao.id + '-qty-' + SID;
      var sizeId = 'ao-' + ao.id + '-size-' + SID;

      var outer = ce('div');
      var row   = ce('div');
      row.style.cssText = 'display:flex;align-items:center;border:1.5px solid #e0e0e0;border-radius:8px;transition:border-color 0.15s,background 0.15s;cursor:pointer;font-family:"Space Grotesk",sans-serif;';

      var cb = ce('input'); cb.type = 'checkbox'; cb.id = cbId;
      cb.setAttribute('data-price', ao.price); cb.setAttribute('data-label', ao.label); cb.setAttribute('data-handle', ao.handle || '');
      cb.style.cssText = 'width:16px;height:16px;accent-color:#2d5a27;flex-shrink:0;margin:0 0 0 12px;cursor:pointer;';

      var inner = ce('div'); inner.style.cssText = 'display:flex;align-items:center;gap:8px;flex:1;padding:11px 12px;font-family:"Space Grotesk",sans-serif;';
      var nm = ce('span'); nm.style.cssText = 'flex:1;font-size:18px;font-weight:500;color:#333;font-family:"Space Grotesk",sans-serif;'; nm.textContent = ao.displayLabel || ao.label;
      var pr = ce('span'); pr.style.cssText = 'font-size:18px;font-weight:500;color:#333;font-family:"Space Grotesk",sans-serif;white-space:nowrap;'; pr.textContent = ao.price === 0 ? 'FREE' : fmt(ao.price);
      inner.appendChild(nm);
      if (ao.handle) {
        var infoWrap = ce('span');
        infoWrap.style.cssText = 'position:relative;display:inline-flex;align-items:center;';
        var infoIcon = ce('span');
        infoIcon.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;background:transparent;border:1.5px solid #2d5a27;color:#2d5a27;font-size:12px;font-weight:700;cursor:help;line-height:1;font-family:"Space Grotesk",sans-serif;';
        infoIcon.textContent = 'i';
        infoIcon.setAttribute('aria-label', 'View product');
        infoWrap.appendChild(infoIcon);
        var infoPopup = ce('span');
        infoPopup.style.cssText = 'position:absolute;bottom:calc(100% + 8px);left:50%;transform:translateX(-50%);background:#fff;border:1.5px solid #d0d0d0;border-radius:8px;padding:8px;box-shadow:0 4px 16px rgba(0,0,0,0.18);white-space:nowrap;display:none;z-index:50;';
        var infoLink = ce('a');
        infoLink.href = '/products/' + ao.handle;
        infoLink.target = '_blank';
        infoLink.rel = 'noopener';
        infoLink.textContent = 'View product →';
        infoLink.style.cssText = 'display:inline-block;padding:7px 14px;background:#2d5a27;color:#fff;text-decoration:none;border-radius:6px;font-size:13px;font-weight:600;font-family:"Space Grotesk",sans-serif;';
        infoPopup.appendChild(infoLink);
        infoWrap.appendChild(infoPopup);
        infoWrap.addEventListener('mouseenter', function(){ infoPopup.style.display='block'; });
        infoWrap.addEventListener('mouseleave', function(){ infoPopup.style.display='none'; });
        infoWrap.addEventListener('click', function(e){ e.stopPropagation(); });
        inner.appendChild(infoWrap);
      }
      inner.appendChild(pr);
      row.appendChild(cb); row.appendChild(inner);

      var qw = null, qv = null, bm = null, bp = null, sw = null;

      if (ao.qty) {
        qw = ce('span'); qw.style.cssText = 'display:none;align-items:center;gap:4px;background:#f0f0f0;border-radius:4px;padding:4px 8px;margin-right:10px;flex-shrink:0;font-family:"Space Grotesk",sans-serif;';
        bm = ce('button'); bm.type = 'button'; bm.textContent = '\u2212';
        bm.style.cssText = 'width:26px;height:26px;border:1px solid #ccc;background:#fff;border-radius:3px;font-size:1.1rem;cursor:pointer;color:#2d5a27;font-weight:700;padding:0;line-height:1;display:flex;align-items:center;justify-content:center;font-family:"Space Grotesk",sans-serif;';
        qv = ce('span'); qv.id = qId; qv.style.cssText = 'font-size:1rem;font-weight:600;min-width:18px;text-align:center;font-family:"Space Grotesk",sans-serif;'; qv.textContent = '1';
        bp = ce('button'); bp.type = 'button'; bp.textContent = '+'; bp.style.cssText = bm.style.cssText;
        qw.appendChild(bm); qw.appendChild(qv); qw.appendChild(bp);
        row.appendChild(qw);
      }
      outer.appendChild(row);

      if (ao.sizes !== null) {
        sw = ce('div'); sw.className = 'rf-ao-size-wrap';
        sw.style.cssText = 'display:none;padding:10px 12px;border:1.5px solid #e0e0e0;border-top:none;border-radius:0 0 8px 8px;background:#fafafa;font-family:"Space Grotesk",sans-serif;';
        var swlbl = ce('label'); swlbl.className = 'rf-label'; swlbl.htmlFor = sizeId; swlbl.style.cssText = 'font-size:0.88rem;font-family:"Space Grotesk",sans-serif;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;';
        swlbl.innerHTML = 'SIZE <span class="rf-required">*</span>'; sw.appendChild(swlbl);
        var swwrap = ce('div'); swwrap.className = 'rf-select-wrap';
        swwrap.appendChild(buildSizeSelect(ao.sizes, sizeId, ao.sizePh)); sw.appendChild(swwrap);
        var serr = ce('p'); serr.className = 'rf-size-error';
        serr.style.cssText = 'color:#c0392b;font-size:0.75rem;margin-top:4px;display:none;'; serr.textContent = 'Please select a size.';
        sw.appendChild(serr); outer.appendChild(sw);
      }

      function tog(on) {
        cb.checked = on;
        row.style.borderColor = on ? '#2d5a27' : '#e0e0e0';
        row.style.background  = on ? '#eef6ec' : '';
        if (qw) { qw.style.display = on ? 'flex' : 'none'; }
        if (sw) { sw.style.display = on ? 'block' : 'none'; }
        if (!on && qv) { qv.textContent = '1'; }
        recalc();
      }

      if (ao.qty && bm && bp) {
        (function(bm2, bp2, qv2, sw2, tog2) {
          bm2.addEventListener('click', function(e) {
            e.stopPropagation();
            var c = parseInt(qv2.textContent) || 1;
            if (c <= 1) { tog2(false); } else { qv2.textContent = c - 1; recalc(); }
          });
          bp2.addEventListener('click', function(e) {
            e.stopPropagation();
            qv2.textContent = (parseInt(qv2.textContent) || 1) + 1;
            cb.checked = true; row.style.borderColor = '#2d5a27'; row.style.background = '#eef6ec';
            if (qw) { qw.style.display = 'flex'; }
            if (sw2) { sw2.style.display = 'block'; }
            recalc();
          });
        })(bm, bp, qv, sw, tog);
      }

      cb.addEventListener('change', function() { tog(cb.checked); });
      inner.addEventListener('click', function(e) { e.stopPropagation(); tog(!cb.checked); });
      list.appendChild(outer);
    });

    mount.appendChild(list);
  }

  /* ════════════════════════════════════════════════════════
     CART
  ════════════════════════════════════════════════════════ */
  function copyToForm() {
    /* Look for our own form first, then fall back to Dawn's */
    var form = document.getElementById('rf-cart-form-' + SID) ||
               document.querySelector('form[action*="/cart/add"]');
    if (!form || !wrap) { return; }
    wrap.querySelectorAll('input[type="hidden"][name]').forEach(function(inp) {
      var sel = '[name="' + inp.name.replace(/\[/g, '\\[').replace(/\]/g, '\\]') + '"]';
      var ex  = form.querySelector(sel);
      if (ex) { ex.value = inp.value; }
      else { var c = inp.cloneNode(false); c.style.display = 'none'; form.appendChild(c); }
    });
  }

  function validateAll() {
    /* Validate all pairs */
    var allPairsOk = true;
    for (var pn = 1; pn <= pairCount; pn++) {
      var modelEl = ge('rf-model-p'+pn+'-'+SID) || (pn===1 ? ge('rf-model-'+SID) : null);
      var sizeEl  = ge('rf-size-p'+pn+'-'+SID)  || (pn===1 ? ge('rf-size-'+SID)  : null);
      var mOk = modelEl && modelEl.value.trim().length > 0;
      var sOk = sizeEl  && sizeEl.value.trim().length  > 0;
      highlightField(modelEl, !mOk);
      highlightField(sizeEl,  !sOk);
      if (!mOk || !sOk) {
        var miss = [];
        if (!mOk) { miss.push('Pair '+pn+' Trainer Model'); }
        if (!sOk) { miss.push('Pair '+pn+' UK Size'); }
        showPopup('Please fill in: ' + miss.join(' & '));
        if (!mOk && modelEl) { modelEl.scrollIntoView({ behavior:'smooth', block:'center' }); }
        else if (!sOk && sizeEl) { sizeEl.scrollIntoView({ behavior:'smooth', block:'center' }); }
        allPairsOk = false;
        break;
      }
    }
    if (!allPairsOk) { return false; }
    /* Check lace colours directly from the DOM — don't rely on recalc() return value */
    var colourMissing = false;
    if (wrap) {
      wrap.querySelectorAll('.rf-lace-slot').forEach(function(slot) {
        var ab = slot.querySelector('.rf-lace-btn--active');
        var tv = ab ? ab.getAttribute('data-value') : 'none';
        if (tv !== 'none') {
          var cs = slot.querySelector('.rf-lace-colour-select');
          if (!cs || !cs.value) { colourMissing = true; }
        }
      });
    }
    recalc();
    if (colourMissing) { showPopup('Please select a lace colour before adding to cart.'); return false; }
    /* Check addon sizes — walk up from size-wrap to find the row's checkbox */
    var sizeMissing = false;
    if (wrap) {
      wrap.querySelectorAll('.rf-ao-size-wrap').forEach(function(sw) {
        if (sw.style.display === 'none') { return; } /* hidden = not checked */
        var sel = sw.querySelector('select');
        if (sel && !sel.value) { sizeMissing = true; }
      });
    }
    if (sizeMissing) { showPopup('Please select a size for your add-on.'); return false; }
    return true;
  }

  document.addEventListener('submit', function(e) {
    if (!e.target.matches('form[action*="/cart/add"]')) { return; }
    /* Always prevent traditional form submission on restoration pages — fetch handles it */
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!SID || !wrap) { return; }
    copyToForm();
    validateAll();
  }, true);

  var _fetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('/cart/add') !== -1 && SID && wrap) {
      /* Only intercept once our form is fully initialised */
      copyToForm();
      if (!validateAll()) { return Promise.reject(new Error('Please complete required fields.')); }
    }
    return _fetch.apply(this, arguments);
  };

  /* ════════════════════════════════════════════════════════
     DELIVERY WATCHER
  ════════════════════════════════════════════════════════ */
  function watchDelivery(productHandle) {
    var vPrices = {};
    fetch('/products/' + productHandle + '.js')
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function(d) {
        (d.variants || []).forEach(function(v) { vPrices[String(v.id)] = v.price / 100; });
        console.log('[RF] Variant prices:', vPrices);
      }).catch(function() {});

    var _last = null;
    function check() {
      var extra = null;
      /* FIRST: check our custom rf-variant-pill--active (delivery pills) */
      var activePill = document.querySelector('.rf-variant-pill--active');
      if (activePill) {
        var pillVid = activePill.getAttribute('data-variant-id');
        var pillPrice = activePill.getAttribute('data-variant-price');
        if (pillPrice !== null) {
          extra = Math.max(0, parseFloat(pillPrice) - basePrice);
        } else if (pillVid && vPrices[String(pillVid)] !== undefined) {
          extra = Math.max(0, vPrices[String(pillVid)] - basePrice);
        }
      }
      /* Check all selects on page for "Express" option */
      if (extra === null) {
        var sels = document.querySelectorAll('select');
        for (var i = 0; i < sels.length; i++) {
          var s = sels[i], idx = s.selectedIndex;
          if (idx < 0) { continue; }
          var txt = (s.options[idx] && s.options[idx].text) || '';
          if (/express/i.test(txt)) {
            var m = txt.match(/\+\s*\u00A3?\s*(\d+(\.\d+)?)/);
            extra = m ? parseFloat(m[1]) : (vPrices[String(s.value)] !== undefined ? Math.max(0, vPrices[String(s.value)] - basePrice) : 9);
            break;
          }
          if (s.name === 'id' && vPrices[String(s.value)] !== undefined) {
            extra = Math.max(0, vPrices[String(s.value)] - basePrice);
            break;
          }
        }
      }
      /* Check radio buttons */
      if (extra === null) {
        var rads = document.querySelectorAll('input[type="radio"][name="id"]:checked');
        if (rads.length && vPrices[rads[0].value] !== undefined) {
          extra = Math.max(0, vPrices[rads[0].value] - basePrice);
        }
      }
      /* Check hidden input */
      if (extra === null) {
        var inp = document.querySelector('input[name="id"]');
        if (inp && vPrices[inp.value] !== undefined) { extra = Math.max(0, vPrices[inp.value] - basePrice); }
      }
      if (extra === null || extra === _last) { return; }
      _last = extra;
      if (extra !== deliveryExtra) {
        console.log('[RF] Delivery:', deliveryExtra, '->', extra);
        deliveryExtra = extra;
        recalc();
      }
    }

    document.addEventListener('change', function() { setTimeout(check, 80); });
    document.addEventListener('click',  function() { setTimeout(check, 150); });
    ['variant:changed','variantChange','theme:variant:change'].forEach(function(ev) {
      document.addEventListener(ev, function() { setTimeout(check, 80); });
    });
    /* Poll for 30s to catch Dawn's variant picker hydration */
    var n = 0, t = setInterval(function() { check(); if (++n > 150) { clearInterval(t); } }, 200);
  }

  /* ════════════════════════════════════════════════════════
     NUKE UPLOADERY APP WIDGET
  ════════════════════════════════════════════════════════ */
  function nukeUploadery() {
    document.querySelectorAll('[class*="uploadery"],[id*="uploadery"],[data-uploadery]').forEach(function(el) {
      if (el._rfDel) { return; }
      el._rfDel = true;
      el.parentNode && el.parentNode.removeChild(el);
    });
  }

  /* ════════════════════════════════════════════════════════
     CART POPUP
  ════════════════════════════════════════════════════════ */
  function showCartPopup(item) {
    var ex = document.getElementById('rf-cart-popup');
    if (ex) { ex.parentNode.removeChild(ex); }

    var popup = document.createElement('div');
    popup.id = 'rf-cart-popup';
    /* Position near cart icon — top right below header */
    var cartIcon = document.querySelector('.cart-count-bubble, [href*="/cart"] .icon, header [href*="/cart"], .header__icon--cart, a[href="/cart"]');
    var topPos = '80px';
    if (cartIcon) {
      var rect = cartIcon.getBoundingClientRect();
      topPos = Math.round(rect.bottom + 12) + 'px';
    }
    popup.style.cssText = [
      'position:fixed',
      'top:' + topPos,
      'right:16px',
      'z-index:99999',
      'background:#fff',
      'border:1.5px solid #e0e0e0',
      'border-radius:20px',
      'box-shadow:0 12px 48px rgba(0,0,0,0.22)',
      'padding:28px 32px',
      'min-width:360px',
      'max-width:440px',
      'font-family:Space Grotesk,sans-serif',
      'display:flex',
      'flex-direction:column',
      'gap:16px',
      'animation:rfSlideIn 0.3s ease'
    ].join(';');

    var img = item && item.image ? '<img src="' + item.image + '" style="width:56px;height:56px;object-fit:cover;border-radius:8px;flex-shrink:0;">' : '';
    var title = item && item.product_title ? item.product_title : 'Service';
    var price = item && item.final_line_price ? ('£' + (item.final_line_price / 100).toFixed(2)) : '';

    popup.innerHTML = [
      '<style>@keyframes rfSlideIn{from{transform:translateX(20px);opacity:0}to{transform:translateX(0);opacity:1}}</style>',
      '<div style="display:flex;align-items:center;gap:16px;">',
        img ? img.replace('width:56px;height:56px', 'width:72px;height:72px') : '',
        '<div style="flex:1;min-width:0;">',
          '<p style="margin:0 0 4px;font-size:13px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#2d5a27;">✓ Added to cart</p>',
          '<p style="margin:0;font-size:18px;font-weight:700;color:#1a1a1a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + title + '</p>',
          price ? '<p style="margin:4px 0 0;font-size:16px;color:#555;font-weight:600;">' + price + '</p>' : '',
        '</div>',
        '<button onclick="this.parentNode.parentNode.remove()" style="background:none;border:none;cursor:pointer;color:#aaa;font-size:1.4rem;padding:0;line-height:1;flex-shrink:0;align-self:flex-start;">✕</button>',
      '</div>',
      '<div style="display:flex;gap:10px;">' +
        '<a href="/cart" style="flex:1;text-align:center;padding:13px 12px;background:#f0f0ee;color:#1a1a1a;border-radius:10px;text-decoration:none;font-weight:700;font-size:14px;font-family:Space Grotesk,sans-serif;">View cart</a>' +
        '<form action="/cart" method="post" style="flex:1;margin:0;display:flex;">' +
          '<button type="submit" name="checkout" value="1" style="flex:1;padding:13px 12px;background:#2d5a27;color:#fff;border:none;border-radius:10px;font-weight:700;font-size:14px;font-family:Space Grotesk,sans-serif;cursor:pointer;">Checkout →</button>' +
        '</form>' +
      '</div>'
    ].join('');

    document.body.appendChild(popup);

    /* Close Dawn's cart drawer / notification if they auto-open */
    function closeDawnCart() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.removeAttribute('open');
        if (typeof drawer.close === 'function') { drawer.close(); }
        document.body.classList.remove('overflow-hidden');
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay) { overlay.classList.remove('active', 'animate__overlay'); }
      }
      var notif = document.querySelector('cart-notification');
      if (notif) {
        if (typeof notif.close === 'function') { notif.close(); }
        else { notif.style.display = 'none'; }
      }
    }
    closeDawnCart();
    setTimeout(closeDawnCart, 150);
    setTimeout(closeDawnCart, 400);

    setTimeout(function() {
      if (popup.parentNode) { popup.parentNode.removeChild(popup); }
    }, 20000);
  }

  /* ════════════════════════════════════════════════════════
     INIT
  ════════════════════════════════════════════════════════ */
  function init() {
    wrap = document.querySelector('.rf-wrap[data-section-id]');
    if (!wrap) { return; }

    /* Derive SID from actual rendered button ID to handle Dawn's double-dash format */
    var atcEl = document.querySelector('[id^="rf-atc-bottom-"]');
    SID = atcEl ? atcEl.id.replace('rf-atc-bottom-', '') : wrap.getAttribute('data-section-id');
    basePrice     = parseFloat(wrap.getAttribute('data-base-price')) || 0;
    var productHandle = wrap.getAttribute('data-product-handle') || '';
    console.log('[RF] Init. SID=', SID, 'base=£', basePrice);

    Promise.all([
      fetchLaceColours(),
      new Promise(function(res) { fetchSizes('cushioned-insoles', function(s) { SIZES_INSOLES = s; res(); }); }),
      new Promise(function(res) { fetchSizes('crease-protectors', function(s) { SIZES_CP      = s; res(); }); }),
      new Promise(function(res) { fetchSizes('shoe-trees',        function(s) { SIZES_ST      = s; res(); }); })
    ]).then(function() {

      /* Build lace slots */
      var slotsEl = ge('rf-lace-slots-' + SID);
      if (slotsEl) {
        var loading = slotsEl.querySelector('.rf-loading-msg');
        if (loading) { slotsEl.removeChild(loading); }
        slotCount = 1;
        slotsEl.appendChild(buildSlot(1));
        refreshSlotLabels();
      }

      /* Build add-ons */
      buildAddons();

      /* Wire text field listeners */
      [['rf-model-'+SID,'input'],['rf-size-'+SID,'change'],['rf-notes-'+SID,'input']].forEach(function(p) {
        var el = ge(p[0]);
        if (el && !el._w) { el._w = true; el.addEventListener(p[1], recalc); }
      });

      /* Wire add lace pair button */
      var addBtn = ge('rf-add-lace-pair-' + SID);
      if (addBtn && !addBtn._w) {
        addBtn._w = true;
        addBtn.addEventListener('click', function() {
          slotCount++;
          var newSlot = buildSlot(slotCount);
          ge('rf-lace-slots-' + SID).appendChild(newSlot);
          refreshSlotLabels();
          recalc();
        });
      }

      /* Wire top ATC button — validate first, add to cart if fields filled, else scroll to form */
      var topAtcBtn = document.getElementById('rf-top-atc-' + SID);
      if (topAtcBtn && !topAtcBtn._w) {
        topAtcBtn._w = true;
        topAtcBtn.addEventListener('click', function() {
          var modelEl = ge('rf-model-' + SID);
          var sizeEl  = ge('rf-size-'  + SID);
          var mOk = modelEl && modelEl.value.trim().length > 0;
          var sOk = sizeEl  && sizeEl.value.trim().length  > 0;
          if (!mOk || !sOk) {
            /* Fields not filled — scroll to form */
            var formWrap = document.querySelector('.rf-wrap[data-section-id]');
            if (formWrap) { formWrap.scrollIntoView({behavior:'smooth', block:'start'}); }
            return;
          }
          /* Fields filled — trigger the bottom ATC button logic directly */
          var bottomBtn = ge('rf-atc-bottom-' + SID);
          if (bottomBtn) { bottomBtn.click(); }
        });
      }

      /* Wire bottom ATC button */
      var atcBtn = ge('rf-atc-bottom-' + SID);
      if (atcBtn && !atcBtn._w) {
        atcBtn._w = true;
        atcBtn.addEventListener('click', function() {
          if (!validateAll()) { return; }
          copyToForm();
          /* Add to cart via Ajax so page doesn't redirect */
          var form = document.getElementById('rf-cart-form-' + SID) ||
                     document.querySelector('form[action*="/cart/add"]');
          if (!form) { return; }
          var formData = new FormData(form);
          /* Append all hidden property inputs from our rf-wrap */
          if (wrap) {
            wrap.querySelectorAll('input[type="hidden"][name]').forEach(function(inp) {
              formData.set(inp.name, inp.value);
            });
          }
          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          }).then(function(r) { return r.json(); }).then(function(data) {
            if (data.status) {
              atcBtn.disabled = false;
              atcBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:8px;flex-shrink:0;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Add to cart';
              alert('Error: ' + (data.description || data.message || 'Could not add to cart'));
            } else {
              atcBtn.disabled = true;
              atcBtn.style.background = '#2d5a27';
              atcBtn.textContent = '✓ This pair is in your cart';
              /* Show added-to-cart popup */
              showCartPopup(data);
              /* For each checked accessory add-on with a product handle, add the product to cart */
              document.querySelectorAll('#rf-ao-mount-' + SID + ' input[type="checkbox"][data-handle]').forEach(function(cb2) {
                if (!cb2.checked) return;
                var h = cb2.getAttribute('data-handle');
                if (!h) return;
                _fetch('/products/' + h + '.js')
                  .then(function(r) { return r.ok ? r.json() : Promise.reject(); })
                  .then(function(d) {
                    var v = (d.variants && d.variants.filter(function(x){return x.available;})[0]) || (d.variants && d.variants[0]);
                    if (!v) return;
                    return _fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ id: v.id, quantity: 1 })
                    });
                  }).catch(function() {});
              });
              /* Add extra pairs as separate cart line items with their chosen service tier */
              if (pairCount > 1) {
                for (var epn2 = 2; epn2 <= pairCount; epn2++) {
                  (function(pairNum) {
                    var tierSel2 = ge('rf-tier-p' + pairNum + '-' + SID);
                    var tier2 = tierSel2 ? tierSel2.value : 'revive';
                    var modelEl2 = ge('rf-model-p' + pairNum + '-' + SID);
                    var sizeEl2  = ge('rf-size-p'  + pairNum + '-' + SID);
                    var notesEl2 = ge('rf-notes-p' + pairNum + '-' + SID);
                    var tierHandle2 = tier2 + '-trainer-restoration-service';
                    var props2 = {};
                    props2['Trainer Model'] = modelEl2 ? modelEl2.value.trim() : '';
                    props2['UK Size'] = sizeEl2 ? sizeEl2.value : '';
                    if (notesEl2 && notesEl2.value.trim()) { props2['Notes'] = notesEl2.value.trim(); }
                    props2['Pair'] = String(pairNum);
                    _fetch('/products/' + tierHandle2 + '.js')
                      .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
                      .then(function(d) {
                        var vid2 = d.variants && d.variants[0] && d.variants[0].id;
                        if (!vid2) { return; }
                        return _fetch('/cart/add.js', {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ id: vid2, quantity: 1, properties: props2 })
                        });
                      }).catch(function() {});
                  })(epn2);
                }
              }
            }
          }).catch(function(err) {
            atcBtn.disabled = false;
            atcBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:8px;flex-shrink:0;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Add to cart';
            console.error('[RF] Cart add failed:', err);
          });
        });
      }

      /* Show wrap and calculate */
      wrap.style.display = 'block';
      recalc();

      /* Wire Add Another Pair button in col 1 */
      var col1 = wrap.querySelector('.rf-col');
      if (col1 && !col1._pairBtn) {
        col1._pairBtn = true;
        /* Add pair button */
        var addPairBtn = ce('button');
        addPairBtn.type = 'button';
        addPairBtn.className = 'rf-add-another-pair-btn';
        addPairBtn.id = 'rf-add-pair-btn-' + SID;
        addPairBtn.innerHTML = '+ Add another pair';
        addPairBtn.addEventListener('click', function() {
          pairCount++;
          var newBlock = buildExtraPairBlock(pairCount);
          col1.insertBefore(newBlock, addPairBtn);
          updatePairDiscount();
          recalc();
          newBlock.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
        col1.appendChild(addPairBtn);

        /* Hidden input to carry all pair data */
        var allPairsHid = ce('input');
        allPairsHid.type = 'hidden';
        allPairsHid.name = 'properties[All Pairs]';
        allPairsHid.id = 'rf-prop-allpairs-' + SID;
        allPairsHid.value = '';
        col1.appendChild(allPairsHid);
      }

      /* Email notice */
      if (!ge('rf-email-notice')) {
        var notice = ce('div'); notice.id = 'rf-email-notice'; notice.className = 'rf-email-notice';
        notice.innerHTML = '<span style="font-size:16px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#2d5a27;margin-right:10px;white-space:nowrap;">&#128247; PHOTOS OF YOUR TRAINERS</span><span style="font-size:16px;color:#444;line-height:1.5;">After placing your order, simply <strong>reply to your order confirmation email</strong> with photos of your trainers \u2014 close-ups of any creases, sole, and problem areas are really helpful.</span>';
        var totBar = wrap.querySelector('.rf-totals-addons');
        if (totBar) { wrap.insertBefore(notice, totBar); } else { wrap.appendChild(notice); }
      }

      /* Remove uploadery widget */
      nukeUploadery();
      setTimeout(nukeUploadery, 800);
      setTimeout(nukeUploadery, 2500);

      /* Watch delivery */
      watchDelivery(productHandle);
    });
  }

  /* Global guard — only initialise once even if script loads multiple times */
  if (window._rfInitDone) { return; }
  window._rfInitDone = true;

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

}());